export const DIETARY_RESTRICTIONS_STORAGE_KEY = 'machine-context-dietary-restrictions';
